<div *ngIf="crew != null" class="container-fluid">
    <form #form="ngForm" (ngSubmit)="saveCrew(form)">
        <div mat-dialog-title>
            <div *ngIf="crew.crew_ID" i18n>Edit Crew</div>
            <div *ngIf="!crew.crew_ID" i18n>Add Crew</div>
        </div>

        <div mat-dialog-content>
            <div class="form-inline mb-2">
                <span *ngIf="crew.crew_ID" i18n>Make the necessary changes on the form below then click Submit</span>
                <span *ngIf="!crew.crew_ID" i18n>To add a new crew, complete the form below then click Submit.</span>
                <span class="float-right warning col-sm-4" i18n>* Required Information</span>
            </div>
            <div class="form-group row">                
              <span class="warning">* </span>
              <label class="col-sm-4" for="crew_Name" i18n>Name</label>
                <div class="col-sm-6">
                    <input id="crew_Name" name="crew_Name" class="form-control" [(ngModel)]="crew.crew_Name"
                           required #crew_Name="ngModel"
                           [class.field-error]="form.submitted &&crew_Name.invalid">
                    <div [hidden]="!form.submitted || crew_Name.valid"
                         class="alert alert-danger" i18n>Name is invalid</div>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-4" for="crew_Leader_ID" i18n>Crew Lead</label>
                <div class="col-sm-6">
                    <select [(ngModel)]="crew.selectedCrewLeader" name="crew_Leader_ID" id="crew_Leader_ID" class="form-control col-sm-6 select-bidit"
                            #crew_Lead="ngModel"
                            [class.field-error]="form.submitted &&crew_Lead.invalid">
                        <option [ngValue]="null" selected="">-</option>
                        <option *ngFor="let fieldTech of availablePersonnel" [(ngValue)]="fieldTech.fieldTechnician_ID">{{fieldTech.fieldTechnician_FirstName}} {{fieldTech.fieldTechnician_LastName}}</option>
                    </select>
                    <div [hidden]="!form.submitted || crew_Lead.valid"
                         class="alert alert-danger" i18n>
                        Crew leader is required
                    </div>
                </div>
            </div>
            <div class="form-group row">
              <span class="warning">* </span>
                <label class="col-sm-4" for="crew_members" i18n>Crew Personnel</label>
                <div class="col-sm-6">
                    <mat-select multiple required class="form-control" [(value)]="crew.selectedCrewPersonnel">
                        <mat-option *ngFor="let fieldTech of availablePersonnel" [value]="fieldTech.fieldTechnician_ID">{{fieldTech.fieldTechnician_FirstName}} {{fieldTech.fieldTechnician_LastName}}</mat-option>
                    </mat-select>
                    <div [hidden]="!form.submitted || crew_Lead.valid"
                         class="alert alert-danger" i18n>
                        Crew personnel are required
                    </div>
                </div>
            </div>

            <div class="form-group row">
                <label class="col-sm-4" for="crewColor" i18n>Crew Color</label>
                <input type="color" id="crewColor" name="crewColor" class="form-control col-sm-2" [(ngModel)]="crew.crew_Color">                
            </div>

            <div class="mt-3">
                <div [hidden]="!form.submitted || form.valid"
                     class="alert alert-danger" i18n>
                    Validation issues encountered.  Please review your entered information.
                </div>
            </div>
        </div>

        <mat-dialog-actions align="end">
            <button type="submit" value="submit" name="submit" id="submit" [disabled]="isRequesting" class="btn btn-bidit-submit btn-md mr-3" i18n>Submit</button>
            <a (click)="onNoClick()" class="btn btn-bidit-cancel btn-md" i18n>Cancel</a>
        </mat-dialog-actions>
        <app-spinner [isRunning]="isRequesting"></app-spinner>
    </form>
</div>
